export type LanguageCodes = 'en' | 'sv';

export const DEFAULT_LANGUAGE = 'en';
